export const translations = {
  // Navbar
  nav: {
    home: { it: 'Home', en: 'Home' },
    services: { it: 'Servizi', en: 'Services' },
    booking: { it: 'Prenota', en: 'Book Now' },
    tips: { it: 'Consigli', en: 'Tips' },
    contact: { it: 'Contatti', en: 'Contact' },
    dashboard: { it: 'Dashboard', en: 'Dashboard' },
    logout: { it: 'Logout', en: 'Logout' },
    login: { it: 'Area Riservata', en: 'Admin Area' },
    callNow: { it: 'Chiama Ora', en: 'Call Now' },
  },

  // Homepage
  home: {
    badge: { it: 'Partner Ufficiale Bosch Car Service', en: 'Official Bosch Car Service Partner' },
    heroTitleFallback: { it: 'Oltre 50 Anni di Eccellenza al Vostro Servizio', en: 'Over 50 Years of Excellence at Your Service' },
    statYears: { it: 'Anni di Esperienza', en: 'Years of Experience' },
    statCustomers: { it: 'Clienti Soddisfatti', en: 'Satisfied Customers' },
    statServices: { it: 'Servizi Specializzati', en: 'Specialized Services' },
    bookNow: { it: 'Prenota Ora', en: 'Book Now' },
    discoverServices: { it: 'Scopri i Servizi', en: 'Discover Services' },
    teamTitle: { it: 'Il Nostro Team', en: 'Our Team' },
    teamSubtitle: { it: 'Professionisti certificati con passione per l\'automotive', en: 'Certified professionals with a passion for automotive' },
    teamMechanics: { it: 'Meccanici', en: 'Mechanics' },
    teamRevisions: { it: 'Revisioni', en: 'Inspections' },
    teamOffice: { it: 'Ufficio', en: 'Office' },
    team: { it: 'Team', en: 'Team' },
    valuesTitle: { it: 'I Nostri Valori', en: 'Our Values' },
    valuesSubtitle: { it: 'Ciò che ci distingue e guida il nostro lavoro ogni giorno', en: 'What sets us apart and guides our work every day' },
    excellence: { it: 'Eccellenza', en: 'Excellence' },
    excellenceDesc: { it: 'Standard elevati in ogni intervento', en: 'High standards in every service' },
    punctuality: { it: 'Puntualità', en: 'Punctuality' },
    punctualityDesc: { it: 'Rispetto dei tempi concordati', en: 'Respect for agreed timelines' },
    professionalism: { it: 'Professionalità', en: 'Professionalism' },
    professionalismDesc: { it: 'Team certificato e qualificato', en: 'Certified and qualified team' },
    transparency: { it: 'Trasparenza', en: 'Transparency' },
    transparencyDesc: { it: 'Preventivi chiari e dettagliati', en: 'Clear and detailed estimates' },
    authorized: { it: 'Autorizzato', en: 'Authorized' },
    ctaTitle: { it: 'Prenota il Tuo Appuntamento', en: 'Book Your Appointment' },
    ctaSubtitle: { it: 'Sistema di prenotazione online veloce e intuitivo. Scegli data, ora e servizio in meno di 1 minuto.', en: 'Fast and intuitive online booking system. Choose date, time and service in less than 1 minute.' },
    ctaButton: { it: 'Prenota Subito', en: 'Book Now' },
  },

  // Services page
  services: {
    title: { it: 'I Nostri Servizi', en: 'Our Services' },
    subtitle: { it: 'Soluzioni complete per la cura e la manutenzione della tua auto. Ogni servizio è eseguito con attrezzature Bosch di ultima generazione.', en: 'Complete solutions for the care and maintenance of your car. Every service is performed with latest generation Bosch equipment.' },
    loading: { it: 'Caricamento...', en: 'Loading...' },
    empty: { it: 'Nessun servizio disponibile al momento', en: 'No services available at the moment' },
    learnMore: { it: 'Scopri di più →', en: 'Learn more →' },
    min: { it: 'min', en: 'min' },
  },

  // Service Detail
  serviceDetail: {
    back: { it: 'Torna ai Servizi', en: 'Back to Services' },
    duration: { it: 'Durata', en: 'Duration' },
    bookThis: { it: 'Prenota Questo Servizio', en: 'Book This Service' },
    gallery: { it: 'Galleria', en: 'Gallery' },
    faq: { it: 'Domande Frequenti', en: 'FAQ' },
    notFound: { it: 'Servizio non trovato', en: 'Service not found' },
    backToServices: { it: 'Torna ai Servizi', en: 'Back to Services' },
  },

  // Booking
  booking: {
    title: { it: 'Prenota il Tuo Appuntamento', en: 'Book Your Appointment' },
    subtitle: { it: 'Completa il processo in meno di 1 minuto', en: 'Complete the process in less than 1 minute' },
    step1Title: { it: 'Seleziona i Servizi', en: 'Select Services' },
    step2Title: { it: 'Seleziona Data e Orario', en: 'Select Date & Time' },
    step3Title: { it: 'I Tuoi Dati', en: 'Your Details' },
    continue: { it: 'Continua', en: 'Continue' },
    back: { it: 'Indietro', en: 'Back' },
    date: { it: 'Data', en: 'Date' },
    selectDate: { it: 'Seleziona data', en: 'Select date' },
    availableTime: { it: 'Orario Disponibile', en: 'Available Time' },
    noSlots: { it: 'Nessun orario disponibile', en: 'No time slots available' },
    fullName: { it: 'Nome e Cognome *', en: 'Full Name *' },
    phone: { it: 'Telefono *', en: 'Phone *' },
    email: { it: 'Email', en: 'Email' },
    plate: { it: 'Targa Veicolo *', en: 'License Plate *' },
    carModel: { it: 'Modello Macchina *', en: 'Car Model *' },
    notes: { it: 'Note Aggiuntive', en: 'Additional Notes' },
    notesPlaceholder: { it: 'Eventuali note o richieste specifiche...', en: 'Any additional notes or specific requests...' },
    confirmBooking: { it: 'Conferma Prenotazione', en: 'Confirm Booking' },
    booking: { it: 'Prenotazione...', en: 'Booking...' },
    successTitle: { it: 'Prenotazione Confermata!', en: 'Booking Confirmed!' },
    successMsg: { it: 'Riceverai una conferma via WhatsApp e email con tutti i dettagli del tuo appuntamento.', en: 'You will receive a confirmation via WhatsApp and email with all the details of your appointment.' },
    backHome: { it: 'Torna alla Home', en: 'Back to Home' },
    fillAll: { it: 'Compila tutti i campi obbligatori', en: 'Please fill all required fields' },
    successToast: { it: 'Prenotazione completata con successo!', en: 'Booking completed successfully!' },
    errorToast: { it: 'Errore durante la prenotazione', en: 'Error during booking' },
  },

  // Blog / Consigli
  blog: {
    title: { it: 'I Nostri Consigli', en: 'Our Tips' },
    subtitle: { it: 'Suggerimenti, guide e aggiornamenti dal mondo dell\'automotive per prenderti cura al meglio della tua auto.', en: 'Tips, guides and updates from the automotive world to take the best care of your car.' },
    followFacebook: { it: 'Seguici su Facebook', en: 'Follow us on Facebook' },
    followInstagram: { it: 'Seguici su Instagram', en: 'Follow us on Instagram' },
    loading: { it: 'Caricamento...', en: 'Loading...' },
    empty: { it: 'Nessun articolo disponibile al momento', en: 'No articles available at the moment' },
    readMore: { it: 'Leggi di più →', en: 'Read more →' },
  },

  // Contact
  contact: {
    title: { it: 'Contattaci', en: 'Contact Us' },
    subtitle: { it: 'Siamo qui per rispondere alle tue domande e assisterti in ogni necessità.', en: 'We are here to answer your questions and assist you with every need.' },
    infoTitle: { it: 'Informazioni di Contatto', en: 'Contact Information' },
    address: { it: 'Indirizzo', en: 'Address' },
    phoneLabel: { it: 'Telefono', en: 'Phone' },
    whatsapp: { it: 'WhatsApp', en: 'WhatsApp' },
    emailLabel: { it: 'Email', en: 'Email' },
    hours: { it: 'Orari di Apertura', en: 'Opening Hours' },
    hoursWeek: { it: 'Lunedì - Venerdì: 08:30 - 13:00 / 15:00 - 19:00', en: 'Monday - Friday: 08:30 - 13:00 / 15:00 - 19:00' },
    hoursClosed: { it: 'Sabato - Domenica: Chiuso', en: 'Saturday - Sunday: Closed' },
    followSocial: { it: 'Seguici sui Social', en: 'Follow Us on Social' },
    reviewGoogle: { it: 'Lascia la tua recensione su Google!', en: 'Leave your review on Google!' },
    formTitle: { it: 'Invia un Messaggio', en: 'Send a Message' },
    fullName: { it: 'Nome e Cognome *', en: 'Full Name *' },
    email: { it: 'Email *', en: 'Email *' },
    phone: { it: 'Telefono', en: 'Phone' },
    city: { it: 'Città', en: 'City' },
    plate: { it: 'Targa', en: 'License Plate' },
    carModel: { it: 'Modello Macchina', en: 'Car Model' },
    serviceQuestion: { it: 'Quale servizio vuoi effettuare? *', en: 'What service do you need? *' },
    servicePlaceholder: { it: 'Descrivi il servizio di cui hai bisogno...', en: 'Describe the service you need...' },
    send: { it: 'Invia Messaggio', en: 'Send Message' },
    sending: { it: 'Invio...', en: 'Sending...' },
    successToast: { it: 'Messaggio inviato con successo! Ti risponderemo al più presto.', en: 'Message sent successfully! We will get back to you soon.' },
    errorToast: { it: 'Errore nell\'invio del messaggio. Riprova.', en: 'Error sending message. Please try again.' },
    fillAll: { it: 'Compila tutti i campi obbligatori', en: 'Please fill all required fields' },
  },

  // AI Assistant
  ai: {
    title: { it: 'Assistente AI', en: 'AI Assistant' },
    subtitle: { it: 'Sempre disponibile', en: 'Always available' },
    welcome: { it: 'Ciao! Sono l\'assistente virtuale di Officina Martorana. Come posso aiutarti oggi? Posso fornirti informazioni sui nostri servizi, aiutarti a prenotare un appuntamento o rispondere alle tue domande sull\'auto.', en: 'Hello! I\'m the virtual assistant of Officina Martorana. How can I help you today? I can provide information about our services, help you book an appointment or answer your car questions.' },
    placeholder: { it: 'Scrivi un messaggio...', en: 'Write a message...' },
    error: { it: 'Errore durante la comunicazione con l\'assistente', en: 'Error communicating with the assistant' },
  },

  // Footer
  footer: {
    about: { it: 'Oltre 50 anni di eccellenza nel settore automobilistico. Partner ufficiale Bosch Car Service.', en: 'Over 50 years of excellence in the automotive sector. Official Bosch Car Service partner.' },
    quickLinks: { it: 'Link Rapidi', en: 'Quick Links' },
    servicesTitle: { it: 'Servizi Principali', en: 'Main Services' },
    contactTitle: { it: 'Contatti', en: 'Contact' },
    bookings: { it: 'Prenotazioni', en: 'Bookings' },
    hoursLabel: { it: 'Orari di Apertura:', en: 'Opening Hours:' },
    hoursValue: { it: 'Lun-Ven: 08:30-13:00 / 15:00-19:00', en: 'Mon-Fri: 08:30-13:00 / 15:00-19:00' },
    rights: { it: 'Tutti i diritti riservati.', en: 'All rights reserved.' },
    serviceNames: {
      revisione: { it: 'Revisione Auto', en: 'Vehicle Inspection' },
      tagliando: { it: 'Tagliando', en: 'Car Service' },
      riparazioni: { it: 'Riparazioni Meccaniche', en: 'Mechanical Repairs' },
      vendita: { it: 'Vendita Auto Nuove/Usate', en: 'New/Used Car Sales' },
      noleggio: { it: 'Noleggio Auto', en: 'Car Rental' },
      soccorso: { it: 'Soccorso Stradale 24h', en: '24h Roadside Assistance' },
    },
  },

  // Login
  login: {
    title: { it: 'Area Riservata', en: 'Admin Area' },
    subtitle: { it: 'Accedi al pannello di gestione', en: 'Access the management panel' },
    username: { it: 'Nome Utente', en: 'Username' },
    password: { it: 'Password', en: 'Password' },
    loginBtn: { it: 'Accedi', en: 'Login' },
    logging: { it: 'Accesso...', en: 'Logging in...' },
    error: { it: 'Credenziali non valide', en: 'Invalid credentials' },
  },

  // Dashboard
  dashboard: {
    title: { it: 'Dashboard', en: 'Dashboard' },
    welcome: { it: 'Benvenuto nel pannello di controllo di Officina Martorana', en: 'Welcome to the Officina Martorana control panel' },
    bookings: { it: 'Prenotazioni', en: 'Bookings' },
    bookingsDesc: { it: 'Gestisci appuntamenti', en: 'Manage appointments' },
    services: { it: 'Servizi', en: 'Services' },
    servicesDesc: { it: 'Modifica servizi offerti', en: 'Edit offered services' },
    campaigns: { it: 'Campagne', en: 'Campaigns' },
    campaignsDesc: { it: 'Crea campagne marketing', en: 'Create marketing campaigns' },
    tips: { it: 'Consigli', en: 'Tips' },
    tipsDesc: { it: 'Gestisci articoli', en: 'Manage articles' },
    analytics: { it: 'Analytics', en: 'Analytics' },
    analyticsDesc: { it: 'Statistiche e report', en: 'Statistics and reports' },
    siteContent: { it: 'Contenuti Sito', en: 'Site Content' },
    siteContentDesc: { it: 'Modifica testi e colori', en: 'Edit texts and colors' },
    messages: { it: 'Messaggi', en: 'Messages' },
    messagesDesc: { it: 'Messaggi dal form contatto', en: 'Messages from contact form' },
    goToSection: { it: 'Vai alla sezione →', en: 'Go to section →' },
  },

  // Service name translations (for dynamic DB content)
  serviceNamesEN: {
    'Revisione Auto': 'Vehicle Inspection',
    'Tagliando Auto': 'Car Maintenance Service',
    'Riparazioni Meccaniche': 'Mechanical Repairs',
    'Vendita Auto Nuove e Usate': 'New & Used Car Sales',
    'Noleggio Auto': 'Car Rental',
    'Soccorso Stradale 24h': '24h Roadside Assistance',
    'Messa a Punto Motore': 'Engine Tuning',
    'DPF Cleaner Oxyhtech': 'DPF Cleaner Oxyhtech',
    'TEXA H2 Blaster': 'TEXA H2 Blaster',
  },
};
